import { render, staticRenderFns } from "./NoticePopup.vue?vue&type=template&id=a6bc5bd0&scoped=true&"
import script from "./NoticePopup.vue?vue&type=script&lang=js&"
export * from "./NoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./NoticePopup.vue?vue&type=style&index=0&id=a6bc5bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bc5bd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
